module.exports = __webpack_public_path__ + "static/media/blog-img6.3821ac79.jpg";